import React from 'react';
import { useHistory } from 'react-router-dom';
import { SCREEN_SIZE, APP_URL } from 'types';
import { useSelector } from 'react-redux';
import { HeaderName } from 'carbon-components-react/lib/components/UIShell';
import { selectScreenSize } from 'redux/session/selectors';
import { ReactComponent as LogoBig } from 'assets/images/locate-logo-big.svg';
import { ReactComponent as LogoSmall } from 'assets/images/locate-logo-small.svg';

const TopHeaderLogo: React.FC<Props> = ({ disableNav }) => {
  const screenSize = useSelector(selectScreenSize);
  const history = useHistory();

  return (
    <HeaderName className="global-header-body-logo--wrapper" prefix="">
      {screenSize && screenSize === SCREEN_SIZE.SM ? (
        <LogoSmall
          className="header-logo-img"
          onClick={
            disableNav ? undefined : () => history.push(APP_URL.ROOT_URL)
          }
        />
      ) : (
        <LogoBig
          className="header-logo-img"
          onClick={
            disableNav ? undefined : () => history.push(APP_URL.ROOT_URL)
          }
        />
      )}
    </HeaderName>
  );
};

type Props = {
  disableNav?: boolean;
};

export default TopHeaderLogo;
